import React from 'react';
export function WhatIDoSection() {
  return <section className="w-full bg-brand-light-gray py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-476" data-mp="31h0a1mixi0qv">
      <div className="max-w-4xl mx-auto" data-id="element-477" data-mp="1dkz4as8bvavm">
        <div className="bg-white rounded-lg shadow-sm p-10 md:p-14" data-id="element-478" data-mp="zlzpsdej4cd6">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy leading-tight mb-10" data-id="element-479" data-mp="znsn32395k8i">
            I turn that scattered experimentation into a team that actually
            works together on AI.
          </h2>
          <div className="space-y-8 text-lg text-brand-gray leading-relaxed" data-id="element-480" data-mp="ummr8veapgur">
            <p className="bg-brand-light-gray border-l-4 border-brand-orange rounded-r-lg px-6 py-5" data-id="element-481" data-mp="uopre895wqd7">
              Not a prompt library. Not a one-day workshop. Not an AI tools
              bootcamp.
            </p>
            <p data-id="element-482" data-mp="6x28aci56jlh">
              I work with leaders to get their entire team, the enthusiasts and
              the skeptics, moving in the same direction. Through structured,
              multi-week programs built around your team's real work, not
              generic training.
            </p>
          </div>
        </div>
      </div>
    </section>;
}